import { render, staticRenderFns } from "./trigger-suggester-modal.vue?vue&type=template&id=7a828bdf&"
import script from "./trigger-suggester-modal.vue?vue&type=script&lang=js&"
export * from "./trigger-suggester-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a828bdf')) {
      api.createRecord('7a828bdf', component.options)
    } else {
      api.reload('7a828bdf', component.options)
    }
    module.hot.accept("./trigger-suggester-modal.vue?vue&type=template&id=7a828bdf&", function () {
      api.rerender('7a828bdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tarefas/modal/trigger-suggester-modal/trigger-suggester-modal.vue"
export default component.exports